export const FULL_AMOUNT_WILL_BE_PAID_ENUM = {
  BEFORE_ARRIVAL: 1,
  DURING_STAY: 2
}
